import di from 'di'

export default function(deadline, projectDeadline=null){

    if(deadline === null){
        deadline = projectDeadline
    }

    if(deadline === null){
        deadline = di.get('config').defaultActionDeadline;
    }

    return deadline;
}